import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../../utils/theme'

const P = ({ children, marginBottom, marginTop, withBorder, ...rest }) => (
  <ThemeProvider theme={theme}>
    <Paragraph
      className={cn({
        marginBottom,
        marginTop,
        withBorder,
      })}
      {...rest}
    >
      {children}
    </Paragraph>
  </ThemeProvider>
)

const Paragraph = styled.p`
  font-size: ${props => props.theme.typography.fontSizeSmaller};
  font-weight: ${props => props.theme.typography.fontWeightNormal};
  color: ${`var(--gameday-body-textColor, ${theme.body.textColor})`};
  margin: 0;
  &.marginBottom {
    margin-bottom: 16px;
  }
  &.marginTop {
    margin-top: 16px;
  }
  &.withBorder {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${props => props.theme.body.headingBorderColor};
  }
`

P.defaultProps = {
  marginBottom: true,
  marginTop: true,
  withBorder: false,
}

export default P
